module.exports = __webpack_public_path__ + "static/img/applet.a14b136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/applet.jpg
// module id = 4wfZ
// module chunks = 1